<template>
	<el-button type='text' style="padding: 0;margin-left: 10px;" @click="goback" v-if="$route.name!=='AllInfo'&&!isDialog"><i class="fa fa-arrow-circle-left fa-fw"></i>返回</el-button>
</template>

<script>
	export default {
		name: 'goback',
		props: ['isDialog'],
		watch: {
			
		},

		data() {
			return {

			}
		},
		methods: {
			goback() {
		
					this.$router.back(-1);
				

			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/goback/index.vue